/*
 Created by CHT 2019/12/6 15:56
*/

import {
  CHART_TYPE__STATISTICS,
  CHART_TYPE__DETAILED,
  CHART_TYPE__DATA,
  CHART_TYPE__CALENDAR,
  CHART_TYPE__TEXT,
  CHART_TYPE__FILTER_BTN,
  CHART_TYPE__FILTER_CONTROL,
  CHART_TYPE__MEDIA_CHART,
  CHART_TYPE__CONTAINER_CHART
} from '../types'

import Calendar from "./Calendar"
import DataGrid from "./DataGrid"
import Detailed from "./Detailed"
import FilterBtn from "./FilterBtn"
import FilterControl from "./FilterControl"
import MediaChart from "./MediaChart"
import Statistics from "./Statistics"
import TextGrid from "./TextGrid"
import CustomChart from "./CustomChart"

export default {
  ['control_' + CHART_TYPE__DETAILED]: Detailed,
  ['control_' + CHART_TYPE__DATA]: DataGrid,
  ['control_' + CHART_TYPE__CALENDAR]: Calendar,
  ['control_' + CHART_TYPE__TEXT]: TextGrid,
  ['control_' + CHART_TYPE__FILTER_BTN]: FilterBtn,
  ['control_' + CHART_TYPE__FILTER_CONTROL]: FilterControl,
  ['control_' + CHART_TYPE__MEDIA_CHART]: MediaChart,
  ['control_' + CHART_TYPE__STATISTICS]: Statistics,
  ['control_' + CHART_TYPE__CONTAINER_CHART]: CustomChart
}
